<script>
	import { Router } from "svelte-mini-router";
	import { routerConf } from "@/utils/router";
	import { onMount } from "svelte";
	import { translate } from "@/utils/format";

	import appStore from "@/utils/store";
	import { wait } from "@/utils/common";
	import { initConnectionDetection } from "@/services/connection";
	import { Spinner } from "@/components";

	let user = $state(appStore.get("user"));
	let loading = $state(true);

	let texts = $state({
		LAUNCH_HI_AGAIN_H1: "",
		LAUNCH_HI_AGAIN_P: "",
	});

	onMount(async () => {
		// setTimeout(() => {
		// 	loading = false;
		// }, 1500); // ajusta si quieres un tiempo real

		let retries = 0;
		texts.LAUNCH_HI_AGAIN_H1 = translate(
			"LAUNCH_HI_AGAIN_H1",
			texts.LAUNCH_HI_AGAIN_H1,
		);
		texts.LAUNCH_HI_AGAIN_P = translate(
			"LAUNCH_HI_AGAIN_P",
			texts.LAUNCH_HI_AGAIN_P,
		);

		loading = false;
	});
</script>

{#if loading && user?.firebaseUser}
	<Spinner text="" />
{:else}
	<Router {routerConf} />
{/if}

<style lang="scss">
	:global(html),
	:global(body),
	:global(#app) {
		background: var(--backgroundMain) !important;
		color: var(--textColor);
		margin: 0;
		padding: 0;
		font-family: "Montserrat", sans-serif;
	}

	.splash {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		height: 100vh;
		text-align: center;
		background: var(--backgroundMain);
		animation: fadeIn 0.5s ease-out;
	}

	.splash__logo {
		width: 65px;
		height: auto;
		margin-bottom: 1.5rem;
		filter: drop-shadow(0 4px 10px rgba(0, 0, 0, 0.05));
		animation: popIn 0.8s ease;
	}

	.splash__text h1 {
		font-size: 20px;
		font-weight: 600;
		color: var(--black);
		line-height: initial;
		letter-spacing: normal; /* o 0.05em */
		margin-bottom: 10px;
	}

	.splash__text p {
		font-size: 14px;
		color: var(--subtleText);
		opacity: 0.8;
		letter-spacing: normal; /* o 0.05em */
	}

	@keyframes fadeIn {
		from {
			opacity: 0;
		}
		to {
			opacity: 1;
		}
	}

	@keyframes popIn {
		0% {
			transform: scale(0.8);
			opacity: 0;
		}
		100% {
			transform: scale(1);
			opacity: 1;
		}
	}
</style>
